import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'

import Markdown from '../Markdown/Markdown'
import Image from '../ui/Image/Image'
import ConnectingLine from './ConnectingLine'
import useIsMobile from '../../hooks/useIsMobile'
import { getImageUrl } from '../../utils'
import styles from './ProductMilestone.module.scss'

function ProductMilestone({ widgetData }) {
  const { title: heading, countries, bgImage } = widgetData
  const [selectedPartner, setSelectedPartner] = useState(countries[0])
  const flagRef = useRef(null)
  const [lineCoordinates, setLineCoordinates] = useState({
    startX: 0,
    startY: 0,
    midX: 0,
    endX: 0,
    endY: 0,
  })
  const scrollEleRef = useRef(null)
  const isMobile = useIsMobile()

  useEffect(() => {
    if (isMobile && scrollEleRef.current) {
      scrollEleRef.current.scrollLeft = 445
    }
  }, [isMobile])

  useEffect(() => {
    if (selectedPartner?.id && flagRef?.current) {
      const elem = document.getElementById(selectedPartner.id)
      const rect = elem.getBoundingClientRect()

      const startX = elem.offsetLeft
      const startY = elem.offsetTop + rect.height / 2
      const endX =
        flagRef.current.offsetLeft +
        flagRef.current.getBoundingClientRect().width
      const endY =
        flagRef.current.offsetTop +
        flagRef.current.getBoundingClientRect().height / 2

      setLineCoordinates({
        startX: startX,
        startY: startY,
        midX: startX - 150,
        endX: endX,
        endY: endY,
      })
    }
  }, [selectedPartner])

  useEffect(() => {
    const resizePolylineHandler = () => {
      if (selectedPartner?.id && flagRef?.current) {
        const elem = document.getElementById(selectedPartner.id)

        const rect = elem.getBoundingClientRect()
        const elemOffsetLeft = elem?.offsetLeft || 0
        const elemOffsetTop = elem?.offsetTop || 0

        const startX = elemOffsetLeft
        const startY = elemOffsetTop + rect.height / 2

        const endX =
          (flagRef.current?.offsetLeft || 0) +
          flagRef.current.getBoundingClientRect().width

        const endY =
          (flagRef.current?.offsetTop || 0) +
          flagRef.current.getBoundingClientRect().height / 2

        setLineCoordinates({
          startX: startX,
          startY: startY,
          midX: startX - 150,
          endX: endX,
          endY: endY,
        })
      }
    }

    window.addEventListener('resize', resizePolylineHandler)
    return () => window.removeEventListener('resize', resizePolylineHandler)
  }, [selectedPartner?.id])

  const countryClickHandler = (country) => {
    setSelectedPartner(country)
  }

  return (
    <div className={styles.rootContainer}>
      <h1 className={styles.header}>{heading}</h1>
      <div ref={scrollEleRef} className={styles.outerClass}>
        <div className={styles.scrollable}>
          {isMobile ? (
            <img src={getImageUrl(bgImage)} alt={bgImage.alternativeText} />
          ) : (
            <Image src={getImageUrl(bgImage)} alt={bgImage.alternativeText} />
          )}
          <div className={styles.map}>
            {countries.map((country) => {
              return (
                <button
                  aria-label={`select ${country.name}`}
                  key={country.id}
                  id={country.id}
                  className={classNames(
                    styles['countryCircle'],
                    styles[country.name.toLowerCase()],
                    {
                      [styles.override]: selectedPartner?.name === country.name,
                    }
                  )}
                  style={{
                    top: country.position.top,
                    left: country.position.left,
                    backgroundImage: `url(${getImageUrl(country?.image)})`,
                  }}
                  onClick={() => countryClickHandler(country)}
                ></button>
              )
            })}
          </div>
          <div ref={flagRef} className={styles['flag-container']}>
            <Image
              src={getImageUrl(selectedPartner?.home_largeimage)}
              alt={selectedPartner?.home_largeimage?.alternativeText}
              className={styles.flag}
            />
          </div>
        </div>
      </div>
      {!isMobile && <ConnectingLine lineCoords={lineCoordinates} />}
      {isMobile && (
        <div className={styles['flag-container-mobile']}>
          <Image
            src={getImageUrl(selectedPartner?.home_largeimage)}
            alt={selectedPartner?.home_largeimage?.alternativeText}
            className={styles.flag}
          />
        </div>
      )}
      <div className={styles.partnerships}>
        <span className={styles.partnershipsText}>{selectedPartner?.name}</span>
        <Markdown
          content={selectedPartner?.large_img_title}
          className={classNames(styles.partnershipsText, styles.markdownText)}
        />
        {/* <span className={styles.partnershipsText}>
          {selectedPartner?.large_img_title}
        </span> */}
        {/* <div className={styles.logos}>
          {selectedPartner?.companies &&
            selectedPartner?.companies?.length > 0 &&
            selectedPartner.companies.map((partner) => (
              <Image
                key={partner?.id}
                src={getImageUrl(partner.logo)}
                alt={partner?.logo?.alternativeText}
                className={styles.logo}
              />
            ))}
        </div> */}
      </div>
    </div>
  )
}

export default ProductMilestone
